import { useAtom, useSetAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export const posOrderDeliveryMethodAtom = atomWithStorage(
  "posDeliveryMethod",
  0,
  undefined,
  { getOnInit: true }
);

const usePosOrderDeliveryMethod = () => {
  const atom = useAtom(posOrderDeliveryMethodAtom);
  return atom;
};

export const useSetPosOrderDeliveryMethod = () =>
  useSetAtom(posOrderDeliveryMethodAtom);

export default usePosOrderDeliveryMethod;
